module.exports = __webpack_public_path__ + "static/img/ee2.018b40cf.png";